import Anime from './Anime';
import './AnimeReflect.css';

function AnimeReflect({imgClass}) {
    return (
        <div id="r0">
<Anime imgClass={imgClass}></Anime>
            {/*
            <div id="r1" style={{ backgroundImage: `url("${path + backImgList[backImgId][0]}")` }}>
                <div id="r2" style={{ backgroundImage: `url("${path + backImgList[backImgId][1]}")` }}>
                    <div id="r3" style={{ backgroundImage: `url("${path + backImgList[backImgId][2]}")` }}>
                        <div id="r4" style={{ backgroundImage: `url("${path + backImgList[backImgId][3]}")` }}>
                            <div id="r5" style={{ backgroundImage: `url("${path + backImgList[backImgId][4]}")` }}>
                                <div id="r6" style={{ backgroundImage: `url("${path + backImgList[backImgId][5]}")` }}>
                                    <div id="r7" style={{ backgroundImage: `url("${path + backImgList[backImgId][6]}")` }}>
                                        <div id="r8" style={{ backgroundImage: `url("${path + backImgList[backImgId][7]}")` }}>
                                            <div id="r9" style={{ backgroundImage: `url("${path + backImgList[backImgId][8]}")` }}>
                                                <div id="r10">
                                                    <div id="r11" style={{ backgroundImage: `url("${path + backImgList[backImgId][9]}")` }}>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
    */}
        </div>
    )
}

export default AnimeReflect;